import { AxiosError } from 'axios';
import { toastr } from 'react-redux-toastr';
import branditRails from '../../../../api/brandit_rails';
import { setShippingRateLogsAction, setShippingRateLogAction, setShippingRateLogsStatusAction, setShippingRateLogsErrorsAction, clearShippingRateLogsErrorsAction, setShippingRateLogsMetaAction } from './shippingRateLogs.actions';
export const fetchShippingRateLogs = (params = {}) => async (dispatch) => {
    try {
        dispatch(setShippingRateLogsStatusAction('loading'));
        dispatch(clearShippingRateLogsErrorsAction());
        const { data: { data: shippingRateLogs, meta } } = await branditRails.get('/shipping_rate_logs', { params });
        const logsById = shippingRateLogs.reduce((acc, log) => {
            acc[log.id] = log;
            return acc;
        }, {});
        dispatch(setShippingRateLogsAction(logsById));
        dispatch(setShippingRateLogsMetaAction({
            pageCount: meta.total_pages,
            rowCount: meta.total_count,
            currentPage: meta.current_page,
            perPage: meta.per_page
        }));
        dispatch(setShippingRateLogsStatusAction('succeeded'));
        return shippingRateLogs;
    }
    catch (err) {
        const errorMessage = err instanceof AxiosError ? err.response?.data?.message : err.message;
        dispatch(setShippingRateLogsErrorsAction({ message: errorMessage }));
        dispatch(setShippingRateLogsStatusAction('failed'));
        toastr.error('Error', errorMessage);
        throw err;
    }
};
export const fetchShippingRateLog = (logId) => async (dispatch) => {
    try {
        dispatch(setShippingRateLogsStatusAction('loading'));
        dispatch(clearShippingRateLogsErrorsAction());
        const { data: shippingRateLog } = await branditRails.get(`/shipping_rate_logs/${logId}`);
        dispatch(setShippingRateLogAction(shippingRateLog));
        dispatch(setShippingRateLogsStatusAction('succeeded'));
        return shippingRateLog;
    }
    catch (err) {
        const errorMessage = err instanceof AxiosError ? err.response?.data?.message : err.message;
        dispatch(setShippingRateLogsErrorsAction({ message: errorMessage }));
        dispatch(setShippingRateLogsStatusAction('failed'));
        toastr.error('Error', errorMessage);
        throw err;
    }
};
